import type { HtmlAttributes } from '@studio/design-system/props';
import { Vendor, getCurrentVendor } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

const FooterMap: Record<Vendor, ({ className, ...props }: HtmlAttributes) => ReactElement> = {
  [Vendor.IRIS]: ({ className, ...props }: HtmlAttributes): ReactElement => (
    <div className={twMerge('pb-20 pt-8 font-regular text-secondary', className)} {...props}>
      &copy; Copyright Iris Studio Inc. {new Date().getFullYear()}
    </div>
  ),
  [Vendor.PTZOPTICS]: ({ className, ...props }: HtmlAttributes): ReactElement => (
    <div className={twMerge('pb-20 pt-8 font-regular text-secondary', className)} {...props}>
      <div
        className='h-[34px] w-[175px] bg-contain bg-no-repeat'
        style={{ backgroundImage: 'url(/assets/powered_by.png)' }}
      ></div>
    </div>
  )
};

/** `<Footer>` component. */
export const Footer = FooterMap[getCurrentVendor()];
